import { textForUserOrAIEdited } from "constants/list"
import { canEditTask } from "utils"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const taskListingTransformer = data => ({
  ...data,
  rows: data?.rows?.map(item => {
    return {
      ...item,
      Project: item?.InternalInquiry?.Project,
      editedText: textForUserOrAIEdited()[item?.updatedBySource] || "",
      canEdit: canEditTask(item),
      privileges: createPrivilegeObject(item.privileges),
    }
  }),
})

export default taskListingTransformer
